import isDev from "../util/checkDev";
import { Event } from "../util/classed/Event";
import { uploadEventMediaToStorage } from "../util/firebaseUtil";
import { EventData } from "../util/types";
import { client } from "./api/client";
import { buildALLEventsURL, buildDeleteEventURL, buildEventsURL, buildOwnerCreateEventURL, buildOwnerEditEventURL, buildSingleEventURL } from "./api/urlBuilder";

export async function getClubEvents(clubId: string, token: string, forceRefresh?: boolean) {
    try {
        const response = await client.get(buildEventsURL({ clubId: clubId, forceRefresh }), { token });
        return response.data;
    } catch (error) {
        // Handle errors as needed
        console.error('Error fetching club events:', error);
        throw error;
    }
}

export async function getAllEvents(token: string) {
    try {
        const response = await client.get(buildALLEventsURL({ radius: 100, offset: 0, limit: 50 }), { token });
        return response.data;
    } catch (error) {
        // Handle errors as needed
        console.error('Error fetching all events:', error);
        throw error;
    }
}

export async function createEvent(event: EventData, file: File, token: string) {
    const eventObj = new Event(event);
    const json = eventObj.toDict();
    if (isDev()) console.log(json)
    const eventMedia = await uploadEventMediaToStorage(file, eventObj.getFileName());
    if (eventMedia) {
        Object.assign(json, eventMedia);
        try {
            const response = await client.post(buildOwnerCreateEventURL(), json, { token });
            return response;
        } catch (error) {
            console.error(error)
            throw new Error("Error Creating Event")
        }
    } else {
        throw new Error("Error Uploading File to Storage")
    }
}

export async function editEvent(event: EventData, file: File | null | undefined, token: string) {
    const eventObj = new Event(event);
    const json = eventObj.toDict();
    if (isDev()) console.log(json)
    let eventMedia: Partial<EventData> | null = null;
    if (file) {
        eventMedia = await uploadEventMediaToStorage(file, eventObj.getFileName());
    }
    if (!file || eventMedia) {
        if (eventMedia) {
            Object.assign(json, eventMedia);
        }
        try {
            const response = await client.post(buildOwnerEditEventURL(), json, { token });
            return response;
        } catch (error) {
            console.error(error)
            throw new Error("Error Editing Event")
        }
    } else {
        throw new Error("Error Uploading File to Storage")
    }
}

export async function getSingleEvent(eventId: string, token: string) {
    try {
        const response = await client.get(buildSingleEventURL(eventId), { token });
        return response.data;
    } catch (error) {
        // Handle errors as needed
        console.error('Error fetching single event:', error);
        throw error;
    }
}

export async function deleteSingleEvent(eventId: string, token: string) {
    try {
        const response = await client.post(buildDeleteEventURL(), { eventId: eventId }, { token });
        return response.data;
    } catch (error) {
        // Handle errors as needed
        console.error('Error Deleting event:', error);
        throw error;
    }
}
